import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Link } from "../Link/index.js";
import { Box } from "../Box/index.js";
import { Icon } from "../Icon/index.js";
import { useStyles } from "./RedirectCard.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RedirectCard_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RedirectCard_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const RedirectCard = (t0)=>{
    const $ = c(12);
    let children;
    let linkProps;
    let t1;
    if ($[0] !== t0) {
        ({ children, fullWidth: t1 } = t0), linkProps = _object_without_properties(t0, [
            "children",
            "fullWidth"
        ]);
        $[0] = t0;
        $[1] = children;
        $[2] = linkProps;
        $[3] = t1;
    } else {
        children = $[1];
        linkProps = $[2];
        t1 = $[3];
    }
    const fullWidth = void 0 === t1 ? false : t1;
    const { classes } = useStyles();
    const t2 = fullWidth ? "100%" : "auto";
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            ml: "auto",
            my: "-2",
            mr: "-2",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "chevron_right_outline",
                size: "20",
                color: "stroke.secondary",
                "data-testid": "arrow-forward-ios-icon-test-id"
            })
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== classes.card || $[7] !== t2) {
        t4 = /*#__PURE__*/ jsxs(Box, {
            className: classes.card,
            display: "flex",
            alignItems: "center",
            gap: "8",
            p: "16",
            bgcolor: "bg.greyscale.primary",
            radius: "l",
            width: t2,
            testId: "redirect-card-test-id",
            children: [
                children,
                t3
            ]
        });
        $[5] = children;
        $[6] = classes.card;
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== linkProps || $[10] !== t4) {
        t5 = /*#__PURE__*/ jsx(Link, _object_spread_props(_object_spread({
            stroke: false,
            variant: "simple"
        }, linkProps), {
            children: t4
        }));
        $[9] = linkProps;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
export { RedirectCard };
